import { useEffect, useState } from 'react'
import './App.scss'
import ScreenOverlay from './components/screen-overlay/screen-overlay'
import Wrapper from './components/wrapper'
import watsonAssistant from './utils/watson-assistant'
import { VIRTUAL_TOUR_EVENT, VIRTUAL_TOUR_TABS } from './components/virtual-tour/constant'
import ChatWrapper from './components/chat-wrapper'
import { handleHotspotAction } from './utils/hotspots/handler'
import { useTranslation } from 'react-i18next'
import { VehicleProvider } from './contexts/VehicleContext'
import Cookies from 'js-cookie'

const COOKIES_STATE = {
  MANUAL_OVERWRITE: '_mmscanAssistantOverwrite',
  EXPANDED: '_mmscanAssistantExpanded',
}

function App() {
  const { t } = useTranslation()
  const [showOverlay, setShowOverlay] = useState(false)
  const [mode, setMode] = useState(VIRTUAL_TOUR_TABS.INTERIOR)
  const [expanded, setExpanded] = useState(false)
  useEffect(() => {
    const hasOverwrite = Boolean(Cookies.get(COOKIES_STATE.MANUAL_OVERWRITE))

    if (!hasOverwrite) {
      setTimeout(() => {
        if (window.screen.width >= 1024) {
          setExpanded(true)
        }
      }, 2500)
    } else {
      setExpanded(Cookies.get(COOKIES_STATE.EXPANDED) === 'true')
    }
  }, [])
  useEffect(() => {
    const hotspots = document.getElementsByClassName('hotspot')
    for (var i = 0; i < hotspots.length; i++) {
      ;(function (index) {
        hotspots[index].addEventListener('click', handleHotspotClick)
      })(i)
    }
    document.body.addEventListener('assistant-overlay', (event) => {
      switch (event?.detail?.mode) {
        case VIRTUAL_TOUR_EVENT.START_INTERIOR: {
          setShowOverlay(true)
          setExpanded(false)
          setMode(VIRTUAL_TOUR_TABS.INTERIOR)
          break
        }
        case VIRTUAL_TOUR_EVENT.START_EXTERIOR: {
          setShowOverlay(true)
          setExpanded(false)
          setMode(VIRTUAL_TOUR_TABS.EXTERIOR)
          break
        }
        case VIRTUAL_TOUR_EVENT.HOTSPOT: {
          setShowOverlay(true)
          setExpanded(true)
          break
        }
        default:
          return
      }
    })

    return () => {
      for (var i = 0; i < hotspots.length; i++) {
        ;(function (index) {
          hotspots[index].removeEventListener('click', handleHotspotClick)
        })(i)
      }
    }
  }, [])

  const handleHotspotClick = (event) => {
    handleHotspotAction(event.target.classList.value, (hotspotConfig) => {
      if (hotspotConfig.overlay) {
        setShowOverlay(true)
      }
      if (hotspotConfig.mode) {
        setMode(hotspotConfig.mode)
      }
      if (hotspotConfig.message) {
        setExpanded(true)

        watsonAssistant.getInstance().sendMessage(t(hotspotConfig.message))
      }
    })
  }
  return (
    <VehicleProvider>
      <Wrapper className={showOverlay ? 'application-wrapper--overlay-show' : ''}>
        {showOverlay && (
          <ScreenOverlay
            show={showOverlay}
            onClose={() => {
              setShowOverlay(false)
            }}
            mode={mode}
            setMode={setMode}
          ></ScreenOverlay>
        )}
        <ChatWrapper
          expanded={expanded}
          setExpanded={(isExpanded) => {
            Cookies.set(COOKIES_STATE.MANUAL_OVERWRITE, true)
            Cookies.set(COOKIES_STATE.EXPANDED, isExpanded)
            setExpanded(isExpanded)
          }}
        ></ChatWrapper>
      </Wrapper>
    </VehicleProvider>
  )
}

export default App
